"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FootballAdAllocationEvent;
(function (FootballAdAllocationEvent) {
    FootballAdAllocationEvent["goal"] = "goal";
    FootballAdAllocationEvent["yellowCard"] = "yellowCard";
    FootballAdAllocationEvent["redCard"] = "redCard";
})(FootballAdAllocationEvent = exports.FootballAdAllocationEvent || (exports.FootballAdAllocationEvent = {}));
//# sourceMappingURL=adEvents.js.map